import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';

import { PlanService } from '../services/plans/plan.service';
import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';


@Component({
  moduleId: module.id,
  selector: 'my-plans',
  templateUrl: 'plans.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class PlansComponent extends UsersComponent {

  hasSysOpsPermission:boolean = false;

  priorityOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

 constructor(
    protected router: Router,
    protected planService: PlanService,
    protected providerSevice: ProviderService,
    protected auth: Auth) { super(router, planService,providerSevice); }

  protected getDetailUrl(): string {

    return '/plan/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'plan';
  };

  protected getUsersString(): string {

    return 'Plans';
  };

  alertName:boolean=false;

  ngOnInit(): void {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    this.getUsers({ limit: this.usersPerGet })
}


  closeAlertName(){
    this.alertName=false;
  }

  add(): void {
    if (this.createCalled) {
      this.createCalled = false;
      return;
    }
    if (this.newUser.name==undefined || this.newUser.callsPerMonth==undefined || this.newUser.priority==undefined) {
      this.alertAdd=true;
      this.createCalled = false;
      return;
    }

    let name = this.newUser.name.trim();
    if (!name) {
      this.alertAdd=true;
      this.createCalled = false;
      return;
    }

    let callsPerMonth = this.newUser.callsPerMonth.trim();
    if (!callsPerMonth) {
      callsPerMonth=0
    }

    let priority = this.newUser.priority;

    this.createCalled = true;
    for (let i=0;i<this.users.length;i++){
      if (this.users[i].name.toLowerCase() == name.toLowerCase()){
        this.alertName=true;
        this.createCalled = false;
        return
      }
    }

    this.planService.create({
      name: name,
      callsPerMonth: callsPerMonth,
      priority: priority,
    })
      .then(plan => {

        this.createCalled = false;
        this.users.push(plan);
        this.selectedUser = null;
        this.newUser = {};
        this.alertCreated=true;
        this.configPages()
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        alert(error.message)
        return Promise.reject(error.message || error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/plans/plans.component.ts